import { useStore } from "@/store";

export enum FlowType {
	home = "home",
	store = "store",
}

export default function getFlow() {
	const locationId = useStore.getState().instanceInfo?.location?.id;
	const getFlow = () => {
		if (locationId) return FlowType.store;
		else return FlowType.home;
	};

	const isFromHomeFlow = getFlow() === FlowType.home;
	const isFromStoreFlow = getFlow() === FlowType.store;

	return { isFromHomeFlow, isFromStoreFlow, getFlow };
}
